<!-- components/TooltipPanel.vue -->
<template>
  <v-card outlined :style="{ border: '2px', width: '650px', maxHeight: limitHeight ? '90vh' : 'none' }" max-width="100%" dark class="p-0 tooltip-card"  flat :class="{
    'transparent': transparent,
    'white': !transparent && darkText,
    'dark-bg': !transparent && !darkText
  }" >
  <div class="tooltip-header p-3">
    <v-card-subtitle :class="{ 'dark-text': darkText }" class="m-0 p-0 subtitle-custom">{{hoveredTags(hoveredAnno)}}
    </v-card-subtitle>
    <v-btn
      icon
      small
      class="tooltip-close"
      color="black"
      @click="hideOverlayByClick()"
      aria-label="Close tooltip"
    >
      <v-icon small>mdi-close</v-icon>
    </v-btn>
  </div>
  <div class="tooltip-body">
    <div class="mx-auto">
      <img
        class="mx-auto"
        v-if="getThumbNail(hoveredAnno) !== null"
        :src="getThumbNail(hoveredAnno)"
        alt="Depiction"
        crossorigin="anonymous"
        style="max-width: 600px; display: block;"
      />
    </div>
  <v-card-text :class="{ 'dark-text': darkText }" style="width:600px;max-width: 100%;display: block;
    overflow-wrap: break-word!important;
    word-break: break-word!important;
    white-space: pre-wrap!important;
    color: white;" class="px-6 description-text" v-html="getDescription(hoveredAnno)">
  </v-card-text>
  </div>
  </v-card>
</template>


<script>
import discussion from './discussion.vue'
export default {
  components: { discussion },
  name: 'Cave3DModelTooltip',
  props: {
    transparent: {
      type: Boolean,
      default: true,
    },
    limitHeight: {
    type: Boolean,
    default: true
    },
    darkText: {
      type: Boolean,
      default: false,
    },
    hoveredAnno: {
      type: Object,
      required: true
    },
    relatedDepictions: {
      type: Array,
      required: true
    },
    isVR: {
      type: Boolean,
      default: false
    },
    isHideOverlayByClick: {
      type: Boolean,
      default: true
    }
  },
  methods:{
    onMouseClick(event){
      if (this.hoveredAnno){
        for (const pr of this.hoveredAnno?.Depiction){
          if (pr.depictionID > 0){
            event.preventDefault()
            window.open("https://kucha.saw-leipzig.de/pr/" + pr.depictionID)
          }
        }
      }
    },
    hoveredTags(anno){
      console.log("hoveredTags", anno)
      if (anno && Object.keys(anno).length > 0){
        let depictions = ""
        for (let depiction of anno.Depiction){
          if (depiction.depictionID === -1){
            depictions += "lost"
          } else {
            depictions += "ID " + depiction.depictionID + " (" + depiction.depictionText + ")"
            if (!depiction.depictionExact) {
              depictions += " - uncertain location"
            }
          }
        }
        if (depictions === ""){
          depictions = ";"
        } else {
          depictions = "; Painted Representations: " + depictions
          if (!depictions.includes("lost") && !this.isVR){
            depictions += "\n - click right to show permanently"
          }
        }
        return "Reg: " + anno.Reg + ", No: " + anno.No + depictions
      }
      return "undefined"
    },
    getThumbNail(item){
      if (item && item.Depiction && item.Depiction[0]){
        if (item.Depiction[0]){
          if (item.Depiction[0].depictionID) {
            let masterImage = null
            const pr = this.relatedDepictions.find(element => {
              if (element.depictionID === item.Depiction[0].depictionID) return true
            })
            if (pr) {
              for (const image of pr.relatedImages){
                if (image.imageID === pr.masterImageID){
                  masterImage = image
                }
              }

            }
            if (masterImage !== null){
              if (masterImage.filename !== "accessNotPermitted.png"){
                return process.env.VUE_APP_IIIFAPI + "/iiif/2/kucha%2Fimages%2F" + masterImage.filename + "/full/300,/0/default.jpg"
              } else {
                return null
              }
            } else {
              return null
            }
          }
        }

      }

      return null
    },
    getDescription(item){
      if (item && item.Depiction && item.Depiction[0]){
        if (item.Depiction[0].depictionID) {
          const pr = this.relatedDepictions.find(element => {
            if (element.depictionID === item.Depiction[0].depictionID) return true
          })
          if (pr) {
            return pr.description.replace(/\n/g, "<br>");
            }

          }
        }
      return ""
    },
    hideOverlayByClick: function(){
      this.$log.debug("hideOverlayByClick in Cave3DModelTooltip");
      if (this.isHideOverlayByClick){
        this.$emit("hideOverlayByClick");
      } else {
        this.onMouseClick()
        this.$emit("hideOverlayByClick");
      }
    }

  },
  mounted() {
    this.$log.debug("Cave3DModelTooltip mounted");
  }
}

</script>
<style scoped>
.dark-text {
  color: black !important;
}
.subtitle-custom {
  font-size: 24px; /* etwas größer als Standard */
  line-height: 1.5;
  font-weight: 600;
  max-width: 100%;
}
.tooltip-panel {
  background: white;
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  width: 250px;
}
.dark-bg {
  background-color: rgba(30, 30, 30, 0.95) !important;
}
.description-text {
  font-size: 20px; /* etwas größer als Standard */
  line-height: 1.5;
  color: white;
  white-space: pre-wrap !important;
  overflow-wrap: break-word !important;
  word-break: break-word !important;
}
.tooltip-card {
  pointer-events: auto;
}
.tooltip-header {
  display: flex;
  align-items: start;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 4px;
}
.tooltip-card {
  display: flex;
  flex-direction: column;
}
.tooltip-body {
  overflow-y: auto;
  padding-right: 4px;
}
.tooltip-close {
  align-self: flex-start;
}
.transparent {
  background-color: transparent !important;
}
.white {
  background-color: white !important;
}
</style>